import { defineMessages } from "react-intl";

export const messages = defineMessages({
  subtitle: {
    id: "Ic7Wln",
    defaultMessage:
      "Select shipping zones that will be supplied via this channel. You can assign shipping zones to multiple channels.",
    description: "card subtitle",
  },
});
